import { trigger, state, style, group, animate, transition, keyframes } from '@angular/animations';

export function slideDownAnimation(distance = 100, time = 0.2) {
  return trigger('slideDownAnimation', [
    state('false', style({ transform: `translateY(-${distance}%)`, opacity: 0, display: 'none' })),
    transition('0 => 1', group(
      [
        style({display: 'block'}),
        animate(`${time}s ease-out`, style({
          transform: 'translateY(0)',
          opacity: 1
        }))
      ]
    )),
    transition('1 => 0', group(
      [
        animate(`${time}s ease-out`, style({
          transform: `translateY(-${distance}%)`,
          opacity: 0
        }))
      ]
    ))
  ]);
}



// WEBPACK FOOTER //
// ./src/app/shared/animations/slide-down.animation.ts